import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import type { TranslationConfig } from '../i18n-cache';
import { supportRouteI18n } from '../i18n/support-route-i18n';

export function supportRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${supportRouteI18n(config)}`;
}
